export default __webpack_public_path__ + "static/media/icon-circle-applicant.98275f99.svg";